import { StyleBreakpoints } from '@constants';
import { AppBar, List, ListItem, ListItemIcon, ListItemText } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React, { useEffect } from 'react';

const useStyles = makeStyles(theme => ({
  subMenu: {
    display: 'none',
    flexDirection: 'row',
    height: '89px',
    position: 'relative',
    marginTop: '-20px',
    justifyContent: 'center',
    paddingBottom: '20px',
    paddingLeft: '35px',

    // The Setup submenu is a second 262px rail sitting beside the main nav. On
    // the Setup screen the row is main-nav + this rail + the editor column + the
    // live-preview panel, which overflows once the viewport drops below ~1500px
    // CSS px (e.g. a 1920x1080 monitor at 150% OS scaling ≈ 1280px CSS) and
    // crushes the editor forms. Only show the rail on genuinely wide screens;
    // below xl the page's scroll-spy + live preview carry section navigation.
    [theme.breakpoints.up(StyleBreakpoints.xl)]: {
      display: 'flex',
      flexDirection: 'column',
      width: '262px',
      justifyContent: 'flex-start',
      minHeight: '100vh',
      paddingTop: '14px',
      boxShadow: 'none',
      marginLeft: '0',
      paddingRight: '0 !important',
      position: 'sticky',
      overflowY: 'auto'
    },

    '&::-webkit-scrollbar': {
      width: '8px',
      height: '0px',
      paddingRight: '6px'
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#e7e7e7',
      width: '8px',
      borderRadius: '4px'
    }
  },
  menuItem: {
    margin: '8px auto'
  },
  itemIcon: {
    width: '22px',
    minWidth: '22px'
  },
  itemText: {
    marginLeft: '35px'
  }
}));

const SubMenu = ({ tabsInfo, exactTab }) => {
  const classes = useStyles();

  const handleMenuClick = sectionName => {
    const targetBox = document.getElementById(sectionName);

    if (targetBox) {
      targetBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };

  useEffect(() => {
    if (exactTab) {
      handleMenuClick(exactTab);
    }
  }, [exactTab]);

  if (!tabsInfo?.length) {
    return null;
  }

  return (
    <AppBar
      className={`${classes.subMenu} !bg-white !text-slate-700 !shadow-none border-0 border-r border-solid border-slate-200`}>
      <List component="nav">
        {tabsInfo.map((tabInfo, key) => {
          return (
            <ListItem
              button
              key={key}
              className={`${classes.menuItem} !rounded-xl hover:!bg-slate-100 transition-colors`}
              onClick={() => handleMenuClick(tabInfo.name)}>
              <ListItemIcon className={classes.itemIcon}>
                <img src={tabInfo.icon} width={22} alt={tabInfo.label} />
              </ListItemIcon>
              <ListItemText primary={tabInfo.label} className={classes.itemText} />
              {tabInfo.isBetaFeature && (
                <div className="absolute right-1 inline-flex items-center bg-indigo-50 text-indigo-700 px-2 py-0.5 rounded-md text-[10px] font-bold border border-solid border-indigo-200/55">
                  Beta
                </div>
              )}
            </ListItem>
          );
        })}
      </List>
    </AppBar>
  );
};

export default SubMenu;
